import React from 'react';
import { Link } from 'expo-router';
import { docsVisuals } from '@/content/docsVisuals';
import './DocsVisual.css';

const guides = [
  { visual: 'work', href: '/docs/work', title: 'Put an idea to Work', copy: 'Go from a brief to files you can use.' },
  { visual: 'tools', href: '/docs/tools', title: 'Create something new', copy: 'Find your way around the creative tools.' },
  { visual: 'maps', href: '/docs/maps', title: 'Find your next favorite place', copy: 'Explore the map and plan a day out.' },
];

export default function DocsVisualGallery() {
  return <nav className="docs-visual-gallery" aria-label="Explore visual product guides">{guides.map(item => {
    const capture = docsVisuals[item.visual];
    return <Link key={item.href} href={item.href} asChild><a><div className="docs-visual-gallery-image"><img src={`/docs/screenshots/${capture.image}`} width={capture.width} height={capture.height} alt={capture.alt} loading="lazy" decoding="async" /></div><strong>{item.title} <span aria-hidden="true">↗</span></strong><p>{item.copy}</p></a></Link>;
  })}</nav>;
}
